import {
  ACTIONS_SEQUENCER,
  ACTIONS_SEQUENCER_TRACK,
  redirectOrShowSnackbar,
  RENDER_MODES,
  updateOnePayForAllTrack,
} from './onePayForAllUtils';
import { REASON_TAG_VALUES } from '../../services/frontend-statsd/config/allowed-tags';
import { feStatsdHelper } from '../../utils/frontendStatsdHelper';
import { VPP_SEQUENCER_DATADOG_KEY_CASES } from '../../services/frontend-statsd/config/allowed-keys';
import { ON_DEMAND_IFRAME, PRELOAD_IFRAME, SHOW_SNACKBAR } from '../vip/types';
import { trackEvent } from '../../lib/tracking';
import { getDefaultErrorMessage } from './getDefaultErrorMessage';

export function executeActionsByResponseSequencer({
  response,
  fallback,
  dispatch,
  siteId,
  paramsSequencer,
  statsdConfig,
}) {
  const fallbackUrl = response?.actions?.fallback ?? fallback;
  const actionType = response?.actions?.action_type ?? '';
  const targetUrl = response?.actions?.target;
  const fallbackConfig = {
    fallbackUrl,
    fallbackMessage: response?.actions?.fallback_message,
    timeoutInitialLoad: response?.actions?.timeout,
    timeoutWebviewMessage: response?.actions?.timeout_webview_message,
  };
  const isDismissible = response?.actions?.bottom_sheet?.is_dismissible;
  const snackbarMessage = response?.actions?.snackbar?.message;
  const snackbarType = response?.actions?.snackbar?.type;
  const sequencerTrack = response?.actions?.track;

  feStatsdHelper({
    key: VPP_SEQUENCER_DATADOG_KEY_CASES.GET_RESPONSE_FROM_MSG,
    additionalTags: {
      response_target: Boolean(targetUrl),
      response_fallback: Boolean(fallbackUrl),
      response_empty: !targetUrl && !fallbackUrl,
      response_case: actionType,
    },
    additionalInfo: { response, paramsSequencer },
    shouldLogMessage: !targetUrl || !fallbackUrl || !Object.values(ACTIONS_SEQUENCER).includes(actionType),
    statsdConfig,
  });

  switch (actionType) {
    case ACTIONS_SEQUENCER.BOTTOM_SHEET:
    case ACTIONS_SEQUENCER.LANDING:
      if (!targetUrl) {
        redirectOrShowSnackbar({
          dispatch,
          siteId,
          fallbackToRedirect: fallbackUrl,
          reason:
            actionType === ACTIONS_SEQUENCER.BOTTOM_SHEET
              ? REASON_TAG_VALUES.NO_BOTTOMSHEET_TARGET
              : REASON_TAG_VALUES.NO_LANDING_TARGET,
          message: fallbackConfig.fallbackMessage,
          trackData: sequencerTrack,
        });
        break;
      }
      if (sequencerTrack) {
        trackEvent(updateOnePayForAllTrack(sequencerTrack, ACTIONS_SEQUENCER_TRACK.LOADING));
      }
      dispatch({
        type: ON_DEMAND_IFRAME,
        params: {
          show: true,
          src: targetUrl,
          isRedirectFlow: false,
          renderMode: actionType === ACTIONS_SEQUENCER.BOTTOM_SHEET ? RENDER_MODES.CONTAINER : RENDER_MODES.FULLSCREEN,
          fallbackConfig,
          isDismissible,
          sequencerTrack,
        },
      });
      break;
    case ACTIONS_SEQUENCER.SNACKBAR:
      dispatch({
        type: PRELOAD_IFRAME,
        params: {
          show: false,
        },
      });
      feStatsdHelper({
        key: VPP_SEQUENCER_DATADOG_KEY_CASES.FLOW_END_FROM_MSG,
        additionalTags: {
          end_case: actionType,
          snackbar_type: snackbarType || 'error',
        },
      });
      dispatch({
        type: SHOW_SNACKBAR,
        params: {
          message: snackbarMessage ?? getDefaultErrorMessage(siteId),
          type: snackbarType ? snackbarType.toLowerCase() : 'error',
          delay: 3000,
          called_from: 'pdp',
        },
      });
      if (sequencerTrack) {
        trackEvent(updateOnePayForAllTrack(sequencerTrack, ACTIONS_SEQUENCER_TRACK.SNACKBAR));
      }
      break;
    case ACTIONS_SEQUENCER.NAVIGATE:
      dispatch({
        type: PRELOAD_IFRAME,
        params: {
          show: false,
        },
      });
      if (!targetUrl) {
        redirectOrShowSnackbar({
          dispatch,
          siteId,
          fallbackToRedirect: fallbackUrl,
          reason: REASON_TAG_VALUES.NO_NAVIGATE_TARGET,
          message: fallbackConfig.fallbackMessage,
          trackData: sequencerTrack,
        });
        break;
      }
      if (sequencerTrack) {
        trackEvent(updateOnePayForAllTrack(sequencerTrack, ACTIONS_SEQUENCER_TRACK.NAVIGATE));
      }
      feStatsdHelper({
        key: VPP_SEQUENCER_DATADOG_KEY_CASES.FLOW_END_FROM_MSG,
        additionalTags: {
          end_case: actionType,
        },
      });
      window.location.href = targetUrl;
      break;
    default:
      dispatch({
        type: PRELOAD_IFRAME,
        params: {
          show: false,
        },
      });
      redirectOrShowSnackbar({
        dispatch,
        siteId,
        fallbackToRedirect: null,
        reason: REASON_TAG_VALUES.UNKNOWN_CASE,
        message: fallbackConfig.fallbackMessage,
        trackData: sequencerTrack,
      });
      break;
  }
}
